import Plyr from 'plyr'
import 'plyr/src/sass/plyr.scss'
import { on } from 'delegated-events'

const $spinner = document.querySelector('.site-nav .nav-item.is-home .spinner')
const $modal = document.querySelector('.modal-video')

const state = {
  slideItems: [],
  slideNavs: [],
  activeIndex: -1,
  timer: null
}

const fn = {
  init: () => {
    state.slideItems = document.querySelectorAll('.video-slide-item')
    state.slideNavs = document.querySelectorAll('.video-slide-nav-item')

    if (state.slideItems.length) {
      $spinner.classList.add('animate')

      fn.startTimer()

      on('click', '.video-slide-nav-item', fn.go)
      on('click', '.video-slide-item', fn.openModal)
      on('click', '.modal-video__close', fn.closeModal)

      fn.activate(0)

      setTimeout(() => {
        document.querySelectorAll('video[data-src]').forEach(el => {
          el.src = el.dataset.src
        })
      }, 3000)
    }
  },

  startTimer: () => {
    if (state.timer) {
      clearInterval(state.timer)
    }

    state.timer = setInterval(fn.tick, 10000)
  },

  tick: () => {
    const nextIndex = state.activeIndex + 1 >= state.slideItems.length ? 0 : state.activeIndex + 1
    state.activeIndex = nextIndex

    fn.activate(nextIndex)
  },

  activate: (index) => {
    document.querySelector('.video-slide-item.is-active').classList.remove('is-active')
    state.slideItems[index].classList.add('is-active')

    document.querySelector('.video-slide-nav-item.is-active').classList.remove('is-active')
    state.slideNavs[index].classList.add('is-active')

    $spinner.classList.remove('animate')
    $spinner.offsetWidth

    if (state.slideItems[state.activeIndex]) {
      const $oldVideo = state.slideItems[state.activeIndex].querySelector('video')

      if ($oldVideo) {
        $oldVideo.pause()
      }
    }

    state.activeIndex = index

    const $video = state.slideItems[index].querySelector('video')

    if ($video) {
      if ($video.dataset.src) {
        $video.src = $video.dataset.src
      }

      const src = $video.src
      $video.src = src
      $video.play()
    }

    setTimeout(() => {
      $spinner.classList.add('animate')
    }, 60)
  },

  go: (e) => {
    const nextIndex = parseInt(e.target.dataset.index, 10) - 1
    state.activeIndex = nextIndex

    fn.activate(nextIndex)
    fn.startTimer()
  },

  openModal: (e) => {
    e.preventDefault()

    const $project = e.target.closest('.video-slide-item')
    const title = $project.dataset.projectTitle
    const artist = $project.dataset.projectArtist
    const artistUrl = $project.dataset.projectArtistUrl
    const videoUrl = $project.href

    let videoHeaderHtml = `<a href="${artistUrl}">`

    if (title) {
      videoHeaderHtml += `<div>${title}</div>`
    }

    if (artist) {
      videoHeaderHtml += `<div>${artist}</div>`
    }

    videoHeaderHtml += '</a>'

    $modal.querySelector('.modal-video__title').innerHTML = videoHeaderHtml

    const videoHtml = `
      <video id="video-player" playsinline controls>
        <source src="${videoUrl}" type="video/mp4" />
      </video>
    `

    $modal.querySelector('.modal-video__player').innerHTML = videoHtml

    const plyr = new Plyr('#video-player', {
      controls: [
        'play',
        'progress',
        'current-time',
        'mute',
        'volume',
        'fullscreen'
      ],
      loop: {
        active: true
      }
    })

    document.body.classList.add('is-loading-project')
    $modal.classList.add('is-active')

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'))
    }, 250)

    plyr.play()
  },

  closeModal: () => {
    $modal.querySelector('.modal-video__player').innerHTML = null
    $modal.classList.remove('is-active')
    document.body.classList.remove('is-loading-project')
  }
}

export default {
  can: () => document.body.classList.contains('pagetype-directors'),
  run: fn.init
}
